import Vue from 'vue';
import "./src/table.scss"
import EditDataTable from './src/table';
Vue.component('edit-data-table2', EditDataTable);

export default EditDataTable;
